<div class="my-3 my-md-5">
    <div class="container-fluid">
    	<div class="col-sm-6 float-left">
	        <h1 class="page-title">Lead Assignment Setting</h1>
	    </div>
	</div>
</div>    

<div class="container-fluid px-4 pt-4 card">
    <div class="card">
        <div class="tableFixHead" style="overflow: scroll">
        <table class="table table-striped doctorTable">
            <thead>
                <tr>
                    <th style="width: 50px;">#</th>
                    <th class="col-3">Treatment Category</th>
                    <th>Circles</th>
                   
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let tc of treatCategory;let index = index;">
                    <td >{{index+1}}</td>
                    <td>{{tc.name}}</td>
                    <td>
                        <div class="citiesshow" *ngFor="let circle of circles;" (click)="openBdsDialog(circle.id,tc.id)">
                            {{circle.name}}
                        </div>
                    </td>
                    
                </tr>
            </tbody>
        </table>
        </div>
    </div>
</div>

  
